import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'
import WindowEvents from 'decorators/WindowEvents'
import { entranceTransitions, exitTransitions } from 'components/Modal'
import Div from 'components/Div'
import { toastController, TOAST_EVENTS } from './ToastController'

const DefaultContainer = styled(Div)`
  animation-name: ${props => props.show ? entranceTransitions[props.slideInAnimation] : exitTransitions[props.slideInAnimation]};
  animation-duration: ${props => props.transitionDuration}ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
`
DefaultContainer.defaultProps = {
  slideInAnimation: 'fade'
}

const Timer = styled(Div)`
  animation-name: ${entranceTransitions.fade};
  animation-duration: ${props => props.duration}ms;
  animation-play-state: ${props => props.isRunning ? 'running' : 'paused'};
`

class Toast extends React.Component {
  static propTypes = {
    in: PropTypes.bool.isRequired, // injected by ReactTransitionGroup
    toastId: PropTypes.string.isRequired, // injected by ToastContainer
    closeToast: PropTypes.func.isRequired, // injected by ToastContainer
    registerEventListener: PropTypes.func.isRequired,
    transitionDuration: PropTypes.number,
    duration: PropTypes.number,
    pauseOnHover: PropTypes.bool,
    closeOnClick: PropTypes.bool,
    closeOnPageClick: PropTypes.bool,
    slideInAnimation: PropTypes.oneOf([ 'fade', 'top', 'right', 'bottom', 'left' ]),
    onEnter: PropTypes.func,
    onEntered: PropTypes.func,
    onExit: PropTypes.func,
    onExited: PropTypes.func,
    Container: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string])
  }

  static defaultProps = {
    closeOnPageClick: false,
    transitionDuration: 300,
    duration: 4000,
    pauseOnHover: true,
    closeOnClick: false,
    onEnter: () => {},
    onEntered: () => {},
    onExit: () => {},
    onExited: () => {},
    Container: DefaultContainer
  }

  constructor (props) {
    super(props)
    this.state = {
      isTimerRunning: true
    }
    props.registerEventListener('mousedown', this.onPageClick)
  }

  onPageClick = (e) => {
    const { closeOnPageClick, closeToast } = this.props
    if (closeOnPageClick && this.container && !this.container.contains(e.target)) {
      closeToast()
    }
  }

  onToastClick = () => this.props.closeOnClick && this.props.closeToast()

  stopTimer = () => this.props.pauseOnHover && this.setState({ isTimerRunning: false })

  resumeTimer = () => this.props.pauseOnHover && this.setState({ isTimerRunning: true })

  onExited = () => {
    const { toastId, onExited } = this.props
    onExited()
    toastController.emit(TOAST_EVENTS.CLOSED, toastId)
  }

  render () {
    const { children, closeToast, transitionDuration, duration, slideInAnimation, Container } = this.props
    const { onEnter, onEntered, onExit } = this.props
    const { isTimerRunning } = this.state

    return (
      <Transition in={this.props.in} timeout={transitionDuration} onEnter={onEnter} onEntered={onEntered} onExit={onExit} onExited={this.onExited} mountOnEnter unmountOnExit>
        <Container ref={(el) => (this.container = el)} show={this.props.in} transitionDuration={transitionDuration} slideInAnimation={slideInAnimation} onClick={this.onToastClick} onMouseEnter={this.stopTimer} onMouseLeave={this.resumeTimer}>
          {React.Children.map(children, (child) => React.cloneElement(child, { closeToast }))}
          <Timer isRunning={isTimerRunning} onAnimationEnd={closeToast} duration={duration} />
        </Container>
      </Transition>
    )
  }
}

const EnhancedToast = WindowEvents(Toast)
EnhancedToast.Container = DefaultContainer

export default EnhancedToast
